import { render, staticRenderFns } from "./DocumentTemplateSettings.vue?vue&type=template&id=5a751b82&scoped=true&"
import script from "./DocumentTemplateSettings.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a751b82",
  null
  
)

export default component.exports